import React from 'react';
import { useSelector } from 'react-redux';

import LabelElementPillsContainer from '../../../labels/LabelElementPillsContainer';
import { selectLabelsByIds } from '../../../labels/labelSelectors';
import { length } from '../../../../../common/utils/immutableHelper';
import { TaskLabelData } from '../taskPillsTypes';

import './TaskLabelPills.scss';

type TaskLabelPillsProps = TaskLabelData & {
    permissions: number;
};

const TaskLabelPills: React.FC<TaskLabelPillsProps> = ({ labelIds, element, filterQuery, permissions }) => {
    const elementLabels = useSelector(selectLabelsByIds(labelIds));
    const labelCount = length(elementLabels);

    if (!labelCount) return null;

    return (
        <div className="TaskLabelPills">
            {elementLabels && (
                <LabelElementPillsContainer
                    labels={elementLabels}
                    size="xs"
                    element={element}
                    filterQuery={filterQuery}
                    permissions={permissions}
                />
            )}
        </div>
    );
};

export default TaskLabelPills;
